[
 {
  "id": "logo",
  "x": 220,
  "y": 124,
  "w": 510,
  "h": 332
 },
 {
  "id": "panel",
  "x": 52,
  "y": 522,
  "w": 838,
  "h": 984
 }
]